interface EducationFormData {
  type: string;
  providerName: string;
  specialization: string;
  graduationYear: string;
  assignedQualification?: string;
  additionalInformation?: string;
  haveDocument: boolean;
  document?: {
    type: string;
    number: string;
    dateOfIssue: string;
    scansIds?: string[];
  };
}

export interface Education extends EducationFormData {
  id: string;
}

export interface EducationItemProps {
  education: Education;
  onUpdate: () => void;
  isEditing?: boolean;
  onStartEdit?: () => void;
  onCancelEdit?: () => void;
  disabled?: boolean;
}

export interface EducationCreateFormProps {
  employeeId: string;
  onSave: () => void;
  onCancel: () => void;
}

export const CREATE_EDUCATION = 'CREATE_EDUCATION';
